// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2HXHe","info":"PatientInfo_info__1X6qZ"};